export const isCqc = process.env.REACT_APP_IS_CQC === "true";